import React from 'react';
import { compose, withHandlers } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Select } from 'redux-form-material-ui';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import { get } from 'lodash';
import { changeReservationStatus } from './_api';
import withLoader from '../app/withLoader';
import { renderToggleInput } from '../../components/forms/Toggle';

const enhance = compose(
  withLoader,
  withHandlers({
    onSubmit: ({ item, setEditStatusDialog, loadItem, toggleLoader }) => async (values) => {
      toggleLoader();
      const itemsArray = [];
      const serviceArray = [];
      const persons = get(item, 'userWithItems', {});
      Object.keys(persons).map((key) => {
        get(persons, `[${key}]`, []).map((item2) => {
          itemsArray.push(item2.id);
          return {};
        });
        return {};
      });
      const services = get(item, 'services', []);
      services.map((service) => {
        serviceArray.push({ reservationId: service.reservationId, serviceId: service.serviceId });
        return {};
      });
      const valuesToSend = {
        statusWithItems: { [values.status]: itemsArray },
        statusWithReservationServices: { [values.status]: serviceArray },
        sendEmail: values.sendEmail,
      };
      const resp = await changeReservationStatus(valuesToSend);
      if (resp) {
        setEditStatusDialog(false);
        await loadItem(item.id);
      }
      toggleLoader(false);
    },
  }),
  reduxForm({ form: 'editItem' })
);

export default enhance(
  ({ editStatusDialog, setEditStatusDialog, fullScreen, handleSubmit, statusNames }) => (
    <form onSubmit={handleSubmit}>
      <Dialog
        fullScreen={fullScreen}
        open={editStatusDialog.open}
        onClose={() => setEditStatusDialog({ open: false, title: '' })}
        aria-labelledby="responsive-dialog-title"
        style={{ minWidth: 400, width: '80%' }}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle id="responsive-dialog-title">Úprava stavu rezervace</DialogTitle>
        <DialogContent>
          <Grid container={true} spacing={16}>
            <Grid item={true} xs={6} md={6} lg={6}>
              <FormControl style={{ minWidth: 200 }}>
                <InputLabel htmlFor={'status'}>Stav</InputLabel>
                <Field name={`status`} component={Select} placeholder={'status'}>
                  {Object.keys(statusNames).map((item) => (
                    <MenuItem key={item} value={parseInt(item, 10)}>
                      {statusNames[item]}
                    </MenuItem>
                  ))}
                </Field>
              </FormControl>
            </Grid>
            <Grid item={true} xs={12}>
              <Field
                name="sendEmail"
                id="sendEmail"
                label="Odeslat email zákazníkovi"
                component={renderToggleInput}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            onClick={handleSubmit}
            autoFocus
          >
            Uložit
          </Button>
          <Button
            onClick={() => setEditStatusDialog({ open: false, title: '' })}
            color="secondary"
            variant="contained"
          >
            Zrušit
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  )
);



// WEBPACK FOOTER //
// ./src/modules/reservations/editStatusDialog.js